import { Component, OnInit, ElementRef, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { SideNote, Report, Helpers, Priority, Reminder, User } from 'src/app/model';
import { Router } from '@angular/router';
import { SideNoteProvider, ReportProvider } from 'src/app/providers';
import { ReportService } from 'src/app/services/report.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AssignReportModal } from './assign-report/assign-report.modal';
import { Subject } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SystemType } from '../../../model/enums/system.type';
import { ModeService, StompClient, UserService , LogService} from 'src/app/services';
import { SidenoteReminderComponent } from '../../modal';

@Component({
  selector: 'side-notes',
  templateUrl: './side-notes.component.html',
  styleUrls: ['./side-notes.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({ transition: '0.5s', right: 0})),
      state('closed', style({ transition: '0.5s', right: -350})),
      state('left-open', style({ transition: '0.5s', left: 0 })),
      state('left-closed', style({ transition: '0.5s', left: -350 })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
      transition('left-open => left-closed', [
        animate('0.5s')
      ]),
      transition('left-closed => left-open', [
        animate('0.5s')
      ]),
    ])
  ]
})
export class SideNotesComponent implements OnInit, OnDestroy {

  @ViewChild('container') containerDiv: ElementRef;
  isOpen: boolean = false;
  sideNotes: SideNote[] = [];

  currentReport: Report = null;
  currentMode: SystemType;
  modeSub: any;
  reportSub: any;
  assignModal: BsModalRef;
  reminderModal: BsModalRef;
  isRight: boolean = true;
  Priority = Priority;
  Reminder = Reminder;
  stompSubscription: any;
  currentUser: User;
  userSub: any;

  constructor(
    private router: Router,
    private sideNoteProvider: SideNoteProvider,
    private reportService: ReportService,
    private modalService: BsModalService,
    private modeService: ModeService,
    public reportProvider: ReportProvider,
    private stompClient: StompClient,
    public userService: UserService,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(report => this.currentReport = report);
    this.modeSub = this.modeService.mode$.subscribe(mode => {
      if(mode){
        this.currentMode = mode;
      }
    });
    this.loadSideNotes();

    if (localStorage.hasOwnProperty('R-CRM-SIDE-NOTE-POSITION')) {
      this.isRight = localStorage.getItem('R-CRM-SIDE-NOTE-POSITION') === 'true' ? true : false;
    }

    this.stompSubscription = this.stompClient
      .subscribe('/notes')
      .subscribe((user) => {
        if(this.userService.getCurrentUser()){
          if(this.userService.getCurrentUser().ID !== user)
            this.loadSideNotes();
        }
      });

    this.userSub = this.userService.user$.subscribe(user => this.currentUser = user);

  }

  ngOnDestroy(): void {
    if(this.reportSub) this.reportSub.unsubscribe();
    if(this.modeSub) this.modeSub.unsubscribe();
    if(this.stompSubscription) this.stompSubscription.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }

  /** load side notes */
  loadSideNotes(): void {
    this.sideNoteProvider.getSideNotes().subscribe(data => {
      if(data.success){
        this.sideNotes = SideNote.parseArray(data.result);
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement: any): void {
    const clickedInsideBtn = this.containerDiv?.nativeElement.contains(targetElement);
    if (!clickedInsideBtn) {
      this.isOpen = false;
    }
  }

  /** Hide show side notes */
  toggleSideNotes(): void{
    this.isOpen = !this.isOpen;
  }

  /** Add side notes */
  addNotes(): void{
    // let page = this.router.url;
    // if(page === '/dashboard')
    //   this.logService.log('add');

    /*   if(this.currentReport)
      this.sideNotes.push(SideNote.createDefault(this.currentReport));
    else
      this.sideNotes.push(new SideNote()); */

    this.sideNoteProvider.create(this.currentReport)
      .subscribe(data => {
        if(data.success){
          this.sideNotes.unshift(SideNote.parse(data.result));
        }
      });
  }

  /** Remove notes from list */
  removeNotes(note: SideNote): void {
    this.sideNoteProvider.deleteById(note.ID)
      .subscribe(data => {
        if(data.success){
          setTimeout(() => {
            this.sideNotes.splice(this.sideNotes.indexOf(note), 1);
          }, 10);
        }
      });
  }

  /** Save side note when focus out */
  onBlur(id: string, field: string, value: any): void {
    this.sideNoteProvider.save(id, field, value)
      .subscribe(data => {
        if(!data.success)
          this.logService.log(JSON.stringify(data, null, 2));
      });
  }

  /** Open modal to assign report to an application */
  assignReport(note: SideNote): void {
    this.assignModal = this.modalService.show(AssignReportModal, Helpers.getModalConfig());
    const ackSubject = new Subject<Report>();
    this.assignModal.content.subject = ackSubject;
    this.assignModal.content.report = this.currentReport;
    this.assignModal.content.note = note;

    ackSubject.subscribe(result => {
      if(result){
        note.REPORT = result;
      }
    });
  }

  /** Switch side note from left to right */
  switch(): void {
    this.isRight = !this.isRight;
    this.isOpen = false;
    localStorage.setItem('R-CRM-SIDE-NOTE-POSITION', this.isRight.toString());
  }

  /** Reorder notes in array */
  drop(event: CdkDragDrop<any[]>): void {
    // this.logService.log(this.sideNotes[event.previousIndex]);
    // this.logService.log(this.sideNotes[event.currentIndex]);
    moveItemInArray(this.sideNotes, event.previousIndex, event.currentIndex);
    this.sideNoteProvider.reorder(this.sideNotes[event.previousIndex].ID, this.sideNotes[event.currentIndex].ID)
      .subscribe(data => {
        if(!data.success){
          this.logService.log(JSON.stringify(data, null, 2));
        }
      });
  }

  /** Go to report */
  goReport(report: Report): void {
    report.isLoading = true;
    this.reportProvider.getReportById(report.ID)
      .subscribe(data => {
        if (data.success) {
          report.isLoading = false;

          if(this.currentMode === SystemType.BV){
            this.router.navigate(['/report', report.ID, 'general'],
              { state: { report: data.result } });
          }
          else if (this.currentMode === SystemType.EA){
            this.router.navigate(['/report-ea', report.ID, 'general'],
              { state: { report: data.result } });
          }
          this.toggleSideNotes();
        }
      });
  }

  /** Set priority of notes */
  setPriority(note: SideNote, priority: Priority): void{
    note.PRIORITY = priority;
    this.onBlur(note.ID, 'PRIORITY', priority);
  }

  /** Reminder for note  */
  remindMe(note: SideNote, reminder: Reminder): void{
    if(reminder === Reminder.CUSTOM){
      this.reminderModal = this.modalService.show(SidenoteReminderComponent, Helpers.getModalConfig());
      const ackSubject = new Subject<Report>();
      this.reminderModal.content.subject = ackSubject;
      this.reminderModal.content.note = note;

      ackSubject.subscribe(result => {
        if(result){
          // TO DO: Success result
        }
      });
    }else{
      note.REMINDER = reminder;
      this.onBlur(note.ID, 'REMINDER', reminder);
    }
  }

  /**Share this node */
  shareNote(note: SideNote): void {
    if(note.SHARE){
      note.SHARE = false;
      this.onBlur(note.ID, 'SHARE', note.SHARE);
    }
    else {
      note.toShare = true;
    }
  }

  confirmShare(note: SideNote): void {
    this.onBlur(note.ID, 'SHARE', true);
    note.toShare = false;
  }
}
